import { render, staticRenderFns } from "./GoogleSignInMapping.vue?vue&type=template&id=9873352a&scoped=true"
import script from "./GoogleSignInMapping.vue?vue&type=script&lang=js"
export * from "./GoogleSignInMapping.vue?vue&type=script&lang=js"
import style0 from "./GoogleSignInMapping.vue?vue&type=style&index=0&id=9873352a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9873352a",
  null
  
)

export default component.exports